<template>
  <div class="page-gallery scrollable only-y ">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{  $route.name  }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{  $route.name  }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="24" :xs="24">
          <el-row :gutter="10">
            <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
              <el-input placeholder="Código" v-model="searchInput" clearable size="medium"
                @clear="searchInput = null; getAllAction()" @keyup.enter="getAllAction()">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
            <el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5">
              <el-input placeholder="Referencia" v-model="searchReference" clearable size="medium"
                @clear="searchReference = null; getAllAction()" @keyup.enter="getAllAction()">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
            <el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5">
              <el-button type="primary" icon="el-icon-search" size="medium" :loading="loading"
                @keyup.enter="getAllAction()" @click="getAllAction()">Buscar</el-button>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" class="flex-btn">
              <el-button @click="addProduct" icon="el-icon-plus" size="medium" type="success">Nuevo</el-button>
              <el-button class="btn-print" type="default" icon="el-icon-print" size="medium" :loading="loading"
                :disabled="selection.length == 0" @click="printLabelsLocal()">Imprimir labels</el-button>
            </el-col>
          </el-row>


          <el-table :data="all" v-loading="loading" height="500" @select="addSelection" @select-all="addSelection">
            <el-empty slot="empty" description="No hay datos"></el-empty>
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- <el-table-column label="Imagen" prop="urlPath">
              <template slot-scope="scope">
                <el-avatar v-if="scope.row.urlPath" shape="square" :size="70" fit="cover" :src="scope.row.urlPath">
                </el-avatar>
                <el-image v-else class="img-default">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column> -->
            <el-table-column label="Código" prop="code" width="100"></el-table-column>
            <el-table-column label="N° Parte" prop="manufacturer_reference" width="150px"></el-table-column>
            <el-table-column label="Descripción" prop="description"></el-table-column>
            <!-- <el-table-column label="Variaciones" prop="description">
              <template slot-scope="scope">
                <span v-for="item in scope.row.variations" :key="item.id">
                  {{  item.term.value_admin + ', '  }}
                </span>
              </template>
            </el-table-column> -->
            <el-table-column label="Categoría" prop="category" width="220px"></el-table-column>
            <!-- <el-table-column label="Tipo" prop="type" ></el-table-column> -->
            <el-table-column label="Costo" prop="coste" width="100" sortable>
              <template slot-scope="scope">
                {{  scope.row.coste | currency  }}
              </template>
            </el-table-column>

            <el-table-column label="Precio de venta" prop="salePrice" width="150" sortable>
              <template slot-scope="scope">
                {{  scope.row.salePrice | currency  }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="Precio Venta" prop="priceSale" sortable></el-table-column> -->
            <el-table-column width="100px" align="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                  <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"
                    circle></el-button>
                </el-tooltip>
                <el-popconfirm confirm-button-text='Confirmar' cancel-button-text='Cancelar' icon="el-icon-info"
                  icon-color="red" title="Confirmar eliminación" @confirm="deleteAction(scope.row.id)">
                  <el-button slot="reference" v-can="['admin']" type="danger" circle size="mini" icon="el-icon-delete" class="ml-10"
                    :disabled="scope.row.used != '0'">
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="all.length > 0" class="pagination-box animated fadeInRight"
            style="text-align: end; padding-top: 10px">
            <el-pagination layout="total, prev, pager, next" :page-size="pageSize" :total="totalRows"
              @current-change="handleCurrentPage"></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      selection: []
    };
  },
  created() {
    this.getAllAction()
  },
  computed: {
    ...mapGetters('product', ['all', 'search', 'loading', 'totalRows', 'pageSize', 'reference']),
    searchInput: {
      get() { return this.search },
      set(value) { this['product/SET_SEARCH'](value) }
    },
    searchReference: {
      get() { return this.reference },
      set(value) { this['product/SET_REFERENCE'](value) }
    },
  },
  methods: {
    ...mapMutations(['setRightMenu', 'product/SET_SEARCH', 'product/SET_REFERENCE']),
    ...mapActions('product', ['getAllAction', 'deleteAction', 'printLabelsAction']),
    addProduct() {
      this.setRightMenu({
        componentActive: 'product-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Agregar producto',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    handleCurrentPage(val) {
      this.getAllAction(val);
    },
    printLabelsLocal() {
      this.printLabelsAction(this.selection)
    },
    addSelection(selection) {
      this.selection = selection
    },
    handleEdit(index, row) {
      this.setRightMenu({
        componentActive: 'product-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Editar producto',
          btnRemove: false,
          field_id: row.id,
          hidden_btn: true,
          edit: true,
        }
      })
    },
  }
}
</script>
<style>
.flex-btn {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

@media (max-width: 1000px) {
  .flex-btn {
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 10px;

  }

  .btn-print {
    margin-left: 0px !important;
  }
}

.image-slot {
  font-size: 30px;
}

.el-image {
  width: 70px;
  height: 70px;
}

.el-image>.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>